import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import Specialization3 from '../Elements/Specialization3';
import OurServices3 from '../Elements/OurServices3';
import OurValue3 from '../Elements/OurValue3';
import OurProject3 from '../Elements/OurProject3';
import Faq from '../Elements/Faq';
import AboutCompany4 from './AboutCompany4';
import Specialization8 from './Specialization8';
import OurValue4 from './OurValue4';
import OurProject7 from '../Elements/OurProject7';
import Faq5 from './Faq5';
import OurValue7 from './OurValue7';

var bnrimg = require('./../../images/banner/1.jpg');

class FPS extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner title="Diversified services. Unvarying quality." pagename="Services" bgimage={bnrimg}/>
                    <AboutCompany4 />
                    <Specialization8 />
                    <OurValue7 />
                    <OurProject7 />
                    {/* <Faq5 /> */}
                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default FPS;